<template>
  <div>
    <CRow>
      <CCol lg="12">
        <CTableWrapper :items="getRoles" :itemsPerPage="itemsPerPage">
          <template #header>
            <CIcon name="cil-grid"/> Anzahl Rollen <strong>({{ getRoles.length }})</strong>
          </template>
        </CTableWrapper>
      </CCol>
    </CRow>
  </div>
</template>

<script>

  import CTableWrapper from './../base/UserRoleTable'
  import { mapActions, mapGetters } from 'vuex'

  export default {
    name: "List",
    components: {
      CTableWrapper
    },
    data:()=> ({
      itemsPerPage: 25

    }),
    methods: {
      ...mapActions('user', [
        'loadRoles'
      ])
    },

    created() {
      this.loadRoles()
    },

    computed: {
      ...mapGetters('user', [
        'getRoles'
      ])
    }
  }
</script>

<style scoped>

</style>
